module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'logo--hide': _vm.$route.meta.showModal
    },
    attrs: {
      "id": "logo",
      "role": "img",
      "aria-label": "NPO Zappelin logo"
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d54ca686"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/Logo.vue
// module id = 713
// module chunks = 64